import { styled, Typography, type TypographyProps } from "@material-ui/core";

const typographyConstants = {
  variant: "h2" as const,
  component: "h1" as const,
};

const Text = styled(Typography)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  paddingBottom: theme.spacing(1),
}));

export const PageTitle: FC<TypographyProps> = (props) => {
  const { children, ...rest } = props;

  return (
    <Text {...typographyConstants} {...rest}>
      {children}
    </Text>
  );
};
